import "@aws-amplify/ui-react/styles.css";
import {
  Authenticator,
  defaultDarkModeOverride,
  ThemeProvider,
} from "@aws-amplify/ui-react";
import {
} from "@aws-amplify/ui-react";
import { 
  Box, 
  Heading,
  Stack,
  Center,
  Image,
  Text 
} from '@chakra-ui/react'
import React from "react";
import PageTitle from "../controls/PageTitle";

const theme = {
  name: 'my-theme',
  overrides: [defaultDarkModeOverride],
};

class Home extends React.Component {
    render() {
      return (<>
      <Box alignItems="center" justifyContent="space-between" mb={20}>
        <PageTitle>Login</PageTitle>
        <Center>
          <Stack alignContent='center' justifyContent='center'>
            <Center>
              Sign up And Sign in will be available in the future.
            </Center>
            {/* <Text>Login or sign-up to submit your team photos for the Supporters Club Website</Text> */}
          </Stack>
        </Center>
      </Box>
      <Box alignItems="center" justifyContent="space-between" mb={20}>
        <ThemeProvider theme={theme} colorMode="dark">
          <Authenticator hideSignUp={true}/>
        </ThemeProvider>
      </Box>
    </>
    )
  }
}

export default Home;